import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { PackageSalesByClassTypeItemDTO } from "../api/client";

type ClassTypeSalesReportTableProps = {
  isLoading: boolean;
  data: PackageSalesByClassTypeItemDTO[];
};

export function ClassTypeSalesReportTable({
  isLoading,
  data,
}: ClassTypeSalesReportTableProps) {
  const totalSales = data.reduce((sum, row) => sum + row.salesCount, 0);
  const totalRevenue = data.reduce((sum, row) => sum + row.revenue, 0);

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[240px]">ປະເພດຄລາດສ໌</TableHead>
            <TableHead className="w-[120px] text-right">ຈຳນວນທີ່ຂາຍ</TableHead>
            <TableHead className="w-[140px] text-right">ຍອດຂາຍ</TableHead>
            <TableHead className="w-[100px] text-right">% ຍອດຂາຍ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={4}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={4}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            <>
              {data.map((row) => {
                const revenueShare =
                  totalRevenue > 0
                    ? ((row.revenue / totalRevenue) * 100).toFixed(1)
                    : "0.0";

                return (
                  <TableRow key={row.classTypeId}>
                    <TableCell className="font-medium">
                      {row.classTypeName}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {row.salesCount.toLocaleString()}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {row.revenue.toLocaleString("lo-LA")} ກີບ
                    </TableCell>
                    <TableCell className="text-right text-muted-foreground tabular-nums">
                      {revenueShare}%
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow className="bg-muted/40 font-medium">
                <TableCell>ລວມ</TableCell>
                <TableCell className="text-right tabular-nums">
                  {totalSales.toLocaleString()}
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {totalRevenue.toLocaleString("lo-LA")} ກີບ
                </TableCell>
                <TableCell className="text-right tabular-nums">100%</TableCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
